import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { VerticalSpacer } from '../core/core';
import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import styles from '../SCSS/Login.module.scss';

// const AccountLinkPromptDialog = ( { isShow, onHide, email, provider, onLink } ) => (
class CheckinLimitModal extends Component {
  render() {
    return (
      <Modal show={this.props.isShow} onHide={this.props.onHide} dialogClassName={styles.modalDialog} centered>
        <Modal.Header closeButton>
          <Modal.Body>
            <div>
              <h1>You’ve Checked In for Now 💙</h1>
              <p className={`${styles.NormalText} ${styles.forgotPasswordText}`}>
                Thanks for sharing how you’re feeling. To keep check-ins meaningful, you can submit up to{' '}
                <b>3 feelings check-ins per hour.</b>
                <br></br>
                <br></br>You’re welcome to pause, try one of the activities, or come back later to check in again.
              </p>
              <VerticalSpacer ems={2} />
              <div className={styles.forgotPasswordButton}>
                <PrimaryButton onClick={this.props.onHide} centered>
                  Got it
                </PrimaryButton>
              </div>
            </div>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}
//);

export default CheckinLimitModal;
